
import * as TYPES from "./bolActionTypes";

const defaultState = {
  bols: []
};

export default function company(state = defaultState, action) {
  switch (action.type) {
    case TYPES.BOLS:
      return {
        ...state,
        bols: action.value
      };
    case TYPES.BOLS_COUNT:
      return {
        ...state,
        count: action.value
      };
    default:
      return state;
  }
}
